import { ShippingZoneModelType } from '@teinor/erp/types/company/config/shipping/shippingZoneGroup/shippingZone'
import { useParams } from 'react-router-dom'
import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderCountryName, CustomRenderStateName, DeleteRow } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getDictionaryCountries } from '../../../../../../../utils/reducers/getters'
import ModalCreateConfigShippingZone from './ModalCreateConfigShippingZone'
import ModalDeleteConfigSShippingZone from './ModalDeleteConfigShippingZone'

interface SingleConfigShippingZoneProps extends ComponentWithPermissions { }

const SingleConfigShippingZone: React.FC<SingleConfigShippingZoneProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('shippingZone', 'Zona de envío'),
        newText: t('createNewZone', 'Crear nueva zona')
    }
    
    return (
        <BaseScreenTable TableComponent={SingleConfigShippingZoneTable} CreateModalComponent={ModalCreateConfigShippingZone} DeleteModalComponent={ModalDeleteConfigSShippingZone} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface SingleConfigShippingZoneTableProps extends TableComponentProps { }

const SingleConfigShippingZoneTable: React.FC<SingleConfigShippingZoneTableProps> = ({ setTableInstance, userPermissions, setOpened }) => {
    const { t } = useTwinTranslation()
    const { ShippingZoneGroupId } = useParams()
    const countries = getDictionaryCountries()

    const columns: ColumnTableSchema<ShippingZoneModelType> = [
        {
            id: 'country',
            dataKey: 'country',
            label: t('country', 'País'),
            customRender: (parameterValue) => <CustomRenderCountryName countryId={parameterValue} />,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSearchBar',
                extraComponentData: { items: countries, label: t('country', 'País') }
            },
            generalSearchable: false
        },
        {
            id: 'state',
            dataKey: 'state',
            label: t('state', 'Provincia'),
            customRender: (parameterValue, allRowData) => <CustomRenderStateName stateId={parameterValue} allRowData={allRowData} />,
        },
        {
            id: 'postal_code',
            dataKey: 'postal_code',
            label: t('postalCode', 'Código postal')
        },
        {
            id: 'delete',
            dataKey: 'country',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable columns={columns} getDataFrom='/api/app/config/shipping/shippingZone/getAllShippingZonesInner' name='configShippingZones' extraWhereParams={{ ShippingZoneGroupId }} defaultOrder={{ defaultOrderField: 'ShippingZoneGroupId' }} setTableInstance={setTableInstance} hideLoadFiltersButton={true} className='hide_searchbar'
        />
    )
    
}

export default SingleConfigShippingZone